import {CopyButton} from '@mantine/core';

CopyButton.displayName = 'CopyButton';

export {CopyButton, type CopyButtonProps} from '@mantine/core';
